export default {
    wizardType: "JIRA",

    getConnectionParams: (type, model) => ({
        ClientId: model.get("clientId"),
        ClientSecret: model.get("clientSecret"),
        AuthMode: model.get("authMode"),
        EndpointUrl: model.get("endpointUrl"),
        ApiToken: model.get("apiToken"),
        RefreshToken: model.get("refreshToken"),
        Username: model.get("userName"),
        ReturnHTMLContent: "false"
        
    }),
};

